import { svg } from "lit";
const icon = svg `<path d="M19.9038 35.3082L8.59619 24.0005L19.9346 12.6621L21.5653 14.2428L12.9422 22.8659H39.4345V25.1351H12.9422L21.5345 33.7274L19.9038 35.3082Z" fill="currentColor"/>`;
export default icon;
